module.exports = __webpack_public_path__ + "img/text-align-right.03b34774.svg";